import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import moment from 'moment';
import makeAnimated from 'react-select/animated';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { faTrashAlt } from '@fortawesome/free-regular-svg-icons';

import { getContent, getErrorMessage } from '../../../util/responseUtil';
import { ROUTER_CONSTANT } from '../../../constants/routerConstant';
import Dropdown from '../../../components/Common/Dropdown';
import DateRange from '../../../components/DateRange/DateRange';
import API_SETTINGS from '../../../api/apiSettings';
import ActionType from '../../../redux/reducer/globalActionType';
import Alert from '../../../components/Alert/Alert';
import { CheckPermissionComponent } from '../../../util/permission';
import { SETTING_CS_AGENT_VIEW } from '../../../constants/menuPermissionConstant';
import { getErrorCode } from '../../../util/responseUtil';

class CustomerService extends Component {
    constructor(props) {
        super(props);
        this.state = {
            customerService: {
                page: 1,
                limit: 100,
                data: [],
                value: []
            },
            shift: {
                page: 1,
                limit: 100,
                data: [],
                value: 0
            },
            workShift: {
                page: 1,
                limit: 10,
                data: [],
                total: 0
            },
            showDateRange: false,
            periodStart: '',
            periodEnd: '',
            detailWorkShift: {},
            confirmValidationShift: false,
            showLoadMore: true,
            showConfirmAlert: false,
            showConfirmDeleteAlert: false,
            showSuccessAlert: false,
            showSuccessDeletAlert: false,
            showErrorAlert: false,
            showConfirmErrorAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    getInitiateWorkShift = () => {
        API_SETTINGS.getInitiatetWorkShift(this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        workShift: {
                            ...this.state.workShift,
                            total: getContent(res).count_data
                        }
                    })
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getListWorkShift = () => {
        API_SETTINGS.getListWorkShift(this.state.workShift.page, this.state.workShift.limit, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        workShift: {
                            ...this.state.workShift,
                            data: getContent(res)
                        }
                    })
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getListCustomerService = () => {
        API_SETTINGS.getListUserCustomerServiceWorkShift(this.state.customerService.page, this.state.customerService.limit, true, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        customerService: {
                            ...this.state.customerService,
                            data: getContent(res)
                        }
                    });
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getListShift = () => {
        API_SETTINGS.getListShiftWorkShift(this.state.shift.page, this.state.shift.limit, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        shift: {
                            ...this.state.shift,
                            data: getContent(res)
                        }
                    });
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getDateRange = (from, to) => {
        this.setState({
            periodStart: from,
            periodEnd: to
        })
    }

    resetDateRange = () => {
        this.setState({
            periodStart: '',
            periodEnd: ''
        })
    }

    handleLoadMore = async () => {
        await this.setState({
            workShift: {
                ...this.state.workShift,
                page: this.state.workShift.page + 1
            }
        })

        API_SETTINGS.getListWorkShift(this.state.workShift.page, this.state.workShift.limit, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    if (getContent(res).length === 0) {
                        return this.setState({
                            showLoadMore: false
                        })
                    }
                    let arr = this.state.workShift.data.concat(getContent(res))
                    this.setState({
                        workShift: {
                            ...this.state.workShift,
                            data: arr
                        }
                    })
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    handleChangeCustomerService = data => {
        this.setState({
            customerService: {
                ...this.state.customerService,
                value: data.map(data => (data.value))
            }
        })
    }

    handleChangeShift = data => {
        this.setState({
            shift: {
                ...this.state.shift,
                value: data.value
            }
        })
    }

    handleConfirmDeleteShift = data => {
        this.setState({
            showConfirmDeleteAlert: true,
            detailWorkShift: data
        })
    }
    handleDeleteShift = () => {
        const updatedAt = {
            updated_at: this.state.detailWorkShift.updated_at
        }
        API_SETTINGS.deleteWorkShift(updatedAt, this.state.detailWorkShift.id, this.props.token)
            .then(res => {
                this.setState({
                    showSuccessDeletAlert: true,
                    showConfirmDeleteAlert: false
                });
                setTimeout(() => {
                    this.setState({ showSuccessDeletAlert: false });
                    this.getInitiateWorkShift();
                    this.getListWorkShift();
                }, 1500);
            }).catch(err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true,
                    showConfirmDeleteAlert: false
                });
            })
    }

    handleConfirmValidationShift = async () => {
        await this.setState({ confirmValidationShift: true, showConfirmErrorAlert: false })
        this.handleSubmit();
    }

    handleDateRange = e => {
        if (this.dropdownRef && !this.dropdownRef.current.contains(e.target) && this.dateRangeRef && !this.dateRangeRef.current.contains(e.target)) {
            this.setState({
                showDateRange: false
            })
        }
    }

    handleSubmit = async () => {
        await this.setState({ showConfirmAlert: false })

        if (this.state.shift.value === 0 && this.state.periodStart === '' && this.state.periodEnd === '') {
            this.setState({ showErrorAlert: true });
            return setTimeout(() => this.setState({ showErrorAlert: false }), 1500);
        }

        let data = {
            user_cs_id_array: this.state.customerService.value,
            shift_id: this.state.shift.value,
            start_date: this.state.periodStart === '' ? '' : moment(this.state.periodStart).format('YYYY-MM-DD'),
            end_date: this.state.periodEnd === '' ? '' : moment(this.state.periodEnd).format('YYYY-MM-DD')
        }

        if (this.state.confirmValidationShift) {
            data = {
                ...data,
                confirm: this.state.confirmValidationShift
            }
        }

        API_SETTINGS.postDataWorkShift(data, this.props.token)
            .then(res => {
                this.setState({ showSuccessAlert: true })
                setTimeout(() => this.setState({ showSuccessAlert: false }), 1500)
                setTimeout(() => window.location.reload(), 1500)
            }).catch(async err => {
                await this.setState({ errorMessage: getErrorMessage(err) })
                if (getErrorCode(err) === 'SHIFT-RANGE-FOUND') return this.setState({ showConfirmErrorAlert: true })
                this.setState({ showErrorAlertResponse: true })
            })
    }

    componentDidMount() {
        this._isMounted = true;
        this.dropdownRef = createRef();
        this.dateRangeRef = createRef();

        this.getListCustomerService();
        this.getListShift();
        this.getListWorkShift();
        this.getInitiateWorkShift();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.showDateRange !== this.state.showDateRange) {
            if (this.state.showDateRange) {
                document.addEventListener('click', this.handleDateRange)
            }
        }
    }

    componentWillUnmount() {
        this._isMounted = false;

        document.removeEventListener('click', this.handleDateRange);
    }

    render() {
        const animatedComponents = makeAnimated();

        return (
            <CheckPermissionComponent permissionConstant={[SETTING_CS_AGENT_VIEW]} userPermission={this.props.userDetail.permissions}>
                <div className="flex text-gray-600 calculate-layout">
                    <div className="w-full bg-white rounded-lg p-5 relative">
                        <div className="border-b-2 border-gray overflow-y-auto flex" style={{ height: "90%" }}>
                            <div className="w-1/3">
                                <p className="text-darkblue font-bold mb-5">Shift CS</p>
                                <div className="mb-5 ml-0.5">
                                    <label>Nama CS</label>
                                    <Select
                                        id="mlscustomerservicename"
                                        closeMenuOnSelect={false}
                                        components={animatedComponents}
                                        isMulti
                                        placeholder="Pilih Nama CS"
                                        options={this.state.customerService.data.map(data => ({ value: data.user_nexcare_id, label: data.name }))}
                                        onChange={this.handleChangeCustomerService}
                                    />
                                </div>
                                <div className="mb-5 ml-0.5 relative">
                                    <label>Periode</label>
                                    <div className="form-control select-none" id="btnperiodcusomerservice" onClick={() => this.setState({ showDateRange: !this.state.showDateRange })} ref={this.dropdownRef} tabIndex="-1">
                                        {
                                            this.state.periodStart === '' || this.state.periodEnd === '' ?
                                                <div className="flex justify-between items-center">
                                                    <div className="placeholder">Pilih Periode</div>
                                                    <FontAwesomeIcon icon={faChevronDown} className="select-icon" />
                                                </div>
                                                :
                                                <div className="flex justify-between items-center">
                                                    <div>{moment(this.state.periodStart).format('DD/MM/YYYY')} - {moment(this.state.periodEnd).format('DD/MM/YYYY')}</div>
                                                    <FontAwesomeIcon icon={faChevronDown} className="select-icon" />
                                                </div>
                                        }
                                    </div>
                                    <div className={this.state.showDateRange ? "bg-white absolute z-10 w-full mt-1" : "hidden"} ref={this.dateRangeRef}>
                                        <DateRange
                                            getDateRange={this.getDateRange}
                                            resetDateRange={this.resetDateRange}
                                            handleSave={() => this.setState({ showDateRange: !this.state.showDateRange })}
                                        />
                                    </div>
                                </div>
                                <div className="mb-5 ml-0.5">
                                    <label>Shift CS</label>
                                    <Dropdown id="ddlshift" placeholder="Pilih Shift CS"
                                        handleChange={this.handleChangeShift}
                                        data={this.state.shift.data.map(data => ({ value: data.shift_id, label: data.shift_description }))}
                                    />
                                </div>
                            </div>
                            <div className="w-2/3 overflow-y-auto mb-5 pb-5 pl-10">
                                {
                                    this.state.workShift.data.map(workShift =>
                                        <div key={workShift.id} className="flex justify-between py-2 px-8 bg-blue-100 hover:bg-blue-300 rounded text-sm mb-2">
                                            <div className="font-bold w-2/5">{moment(workShift.start_date).format('DD MMM YYYY')} - {moment(workShift.end_date).format('DD MMM YYYY')}</div>
                                            <div className="w-1/5">{workShift.shift_name}</div>
                                            <div className="w-2/5">{workShift.cs_name}</div>
                                            <FontAwesomeIcon icon={faTrashAlt} className="cursor-pointer" onClick={() => this.handleConfirmDeleteShift(workShift)} />
                                        </div>
                                    )
                                }
                                <div className={this.state.showLoadMore && this.state.workShift.total > this.state.workShift.limit ? "flex justify-center" : "hidden"}>
                                    <button type="button" id="btnmore" className="bg-white rounded text-darkblue border border-darkblue focus:outline-none px-10 py-1" onClick={() => this.handleLoadMore()}>Tampilkan Lebih Banyak</button>
                                </div>
                            </div>
                        </div>
                        <div className="absolute bottom-5 right-5">
                            <button type="button" id="btncancel" className="bg-white rounded text-darkblue border border-darkblue focus:outline-none px-10 py-2 mt-3 mr-2" onClick={() => window.location.reload()}>Batal</button>
                            <button type="submit" id="btnsave" className="bg-lightblue rounded text-white border border-lightblue focus:outline-none px-10 py-2 mt-3 ml-2" onClick={() => this.setState({ showConfirmAlert: true })}>Simpan</button>
                        </div>
                    </div>
                    <Alert show={this.state.showConfirmAlert} icon="warning" button={true} title="Apakah Anda yakin mengubah jam kerja?" close={() => this.setState({ showConfirmAlert: false })} submit={() => this.handleSubmit()} />
                    <Alert show={this.state.showConfirmDeleteAlert} icon="warning" button={true} title="Apakah Anda yakin ingin menghapus shift kerja tersebut?" close={() => this.setState({ showConfirmDeleteAlert: false })} submit={() => this.handleDeleteShift()} />
                    <Alert show={this.state.showSuccessAlert} icon="success" title="Data berhasil disimpan!" />
                    <Alert show={this.state.showSuccessDeletAlert} icon="success" title="Data berhasil dihapus!" />
                    <Alert show={this.state.showErrorAlert} icon="warning" title="Tidak ada perubahan data!" />
                    <Alert show={this.state.showConfirmErrorAlert} icon="warning" button={true} title={this.state.errorMessage} close={() => this.setState({ showConfirmErrorAlert: false })} submit={() => this.handleConfirmValidationShift()} />
                    <Alert show={this.state.showErrorAlertResponse} icon="warning" title={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
                </div>
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerService);